<template>
  <div class="w-full h-full">
    <!-- <RutasStart @start="start = true" v-if="!start" /> -->
    <RutaDraw />
  </div>

</template>
<script setup>
import { ref } from 'vue'
import RutasStart from './RutasStart.vue'
import RutaDraw from './RutaDraw.vue'
const start = ref(false);

</script>